import { render, staticRenderFns } from "./EditOrganizationCompanies.vue?vue&type=template&id=cc2ed8a6&scoped=true"
import script from "./EditOrganizationCompanies.vue?vue&type=script&lang=js"
export * from "./EditOrganizationCompanies.vue?vue&type=script&lang=js"
import style0 from "./EditOrganizationCompanies.vue?vue&type=style&index=0&id=cc2ed8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2ed8a6",
  null
  
)

export default component.exports